module.exports = "<router-outlet>\n</router-outlet>\n<!-- <zl-home></zl-home> -->"